export default __webpack_public_path__ + "static/media/People.99ef745b.jpg";